/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
import { memo, useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import {
  Container,
  ContainerActions,
  ActionButton,
  DeleteActionButton,
  BottomButtonsContainer,
  TextEdit,
  ResetButton,
  SearchButton,
  MagnifyingGlass,
  ButtonCreateNewUser,
  Test360Icon,
  HeaderContainer,
  TitleIcon,
  TitleContainer,
  UsersTableCard,
  UsersTableHeading,
  UsersSearchHeading,
  UsersTableTitle,
  UsersSearchControls,
  InventoryToolbar,
  InventorySummary,
  InventoryButtons,
} from './styled'
import Stepper from 'views/components/Stepper'
import { H2, P, PageTitle } from 'views/components/UI/Text'
import { Button, StrokedButton, BackButton } from 'views/components/UI/Buttons'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import Input from 'views/components/UI/TextInput'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import IconMagnifying from 'assets/icons/iconMagnifying.png'
import BluesiteTableComponent from 'views/components/UI/BluesiteTable'
import { useNotification } from 'lib/context/notification.context'
import {
  EvaluatorProps,
  headers,
  HEADERS_ADDED_EVALUATORS_TEST_360,
  HEADERS_ADDED_USERS,
  HEADERS_ADDED_USERS_TEST_360,
  steps,
  UserAdded,
} from './constants'
import DisclaimerModal from './disclaimer-modal'
import UploadModal from './upload-modal'
import DeleteUserAction from './delete-user-action'
import { formatAvailableCredits, getAddUserErrorMessage } from './user-credits'
import { formatTestStatuses, hasAnsweredTest } from './test-status'

import { platformAdminRoutes } from 'router/routes'
import { Row } from 'views/components/UI/Row'
import {
  rootProcessSelector,
  setStepOne,
  setUserListAdded,
  setAcceptedTerms,
  setStepFiveTrigger,
  stepThreeSelector,
  setUserListFailed,
  setLinkDownloadExcelUsersFailed,
} from 'ducks/createProcess' //setStepFive,
import { User } from './constants'
import { mergeUsers } from './main'
import { useSearchUsers } from 'hooks/users/useSearchUser/useSearchUser'
import useGetCompanyDetail from 'hooks/company/useGetCompanyDetail/useGetCompanyDetail'
import useUserImportApiEnabled from 'hooks/company/useUserImportApiEnabled'
import useGetUsersByProcess from 'hooks/process/useGetUsersByProcess/useGetUsersByProcess'
import useDeleteUsersInProcess from 'hooks/process/useDeleteUsersInProcess/use-delete-users-in-process'
import { DEFAULT_LIMIT, USER_ROLE_ID } from 'constants/global.constants'
import _ from 'lodash'
import FinishProcessModal from './finish-process-modal/finish-process-modal'
import { getUsersByProcess, updateAdmins, updateProcess } from 'services/common/process/createProcess/create-process-service'
import { useTranslation } from 'react-i18next'
import getCompanyInfo from 'services/companies/getCompanyInfo/getCompanyInfo'
import getSubscriptionByProcess from 'services/companies/getSubscriptionByProcess'
import type { SubscriptionByProcessData } from 'services/companies/getSubscriptionByProcess/getSubscriptionByProcess'
import useCreateUsersBatch from 'hooks/users/useCreateUsersBatch/useCreaterUsersBatch'
import { CircularProgress } from '@mui/material'
import {
  selectTest360Data,
  set360Data,
  setShowSummary as setReduxShowSummary,
  setShowIntro as setReduxShowIntro,
  setEvaluatedUsers,
  setEvaluators,
  selectEvaluatedUsers,
  selectEvaluators,
  setHas360Test,
} from 'ducks/test360'
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined'
import { usePreventNavigation } from 'views/screens/super-admin/homologation-skills/hooks/usePreventNavigation'
import threeSixtyIcon from 'assets/images/360-clean-icon.png'
import DeleteModal from './delete-modal'
import ModalLoader from 'views/components/UI/ModalLoader'
import AddUserProgressDialog from './add-user-progress-dialog'
import test360UpdateDraft from 'services/process/test360/test360UpdateDraft'
import test360CreateProcess from 'services/process/test360/test360CreateProcess'
import test360GetDraft from 'services/process/test360/test360GetDraft'
import test360DeleteUsers from 'services/process/test360/test360DeleteUsers'
import { STEPS_NEW_PROCESS, STEPS_NEW_PROCESS_360 } from '../constants'

interface AddUserActionProps extends UserAdded {
  addedUsers: User[]
  loadingUserId: string | null
  isAddingAnyUser: boolean
  onAddUser: (user: UserAdded) => void
}

const AddUserAction = memo(
  ({ addedUsers, loadingUserId, isAddingAnyUser, onAddUser, ...item }: AddUserActionProps) => {
    const isUserAdded = addedUsers.some((user) => user.document === item.document)
    const isLoading = loadingUserId === item.document
    const isButtonDisabled = isAddingAnyUser || isUserAdded

    return (
      <ContainerActions>
        <ActionButton
          type="button"
          disabled={Boolean(isButtonDisabled)}
          onClickCapture={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onAddUser(item)
          }}
          style={{
            cursor: isButtonDisabled ? 'default' : 'pointer',
            opacity: isAddingAnyUser && !isLoading ? 0.6 : 1,
          }}
        >
          {isLoading ? (
            <CircularProgress size={20} color="primary" />
          ) : (
            <AddCircleOutlineIcon style={{ color: isUserAdded ? 'gray' : '#2D749C' }} />
          )}
          <TextEdit style={{ color: isUserAdded ? 'gray' : '#2D749C' }}>
            {isLoading ? 'Agregando...' : 'Agregar'}
          </TextEdit>
        </ActionButton>
      </ContainerActions>
    )
  }
)

const CreateUsers = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { getSuccess, getWarning, getError } = useNotification()
  const newUserId = location?.state?.newUserId || null
  const { search, results, paginationUsers, clearSearch } = useSearchUsers()
  const { results: listUsersByProcess } = useSearchUsers()
  const { createUsersBatch, resultsFail, urlExcelUsersFailed } = useCreateUsersBatch()

  const { getOneCompany, companyInfo } = useGetCompanyDetail()
  const { deleteUsersInProcess } = useDeleteUsersInProcess()

  const stepOneData = useSelector(rootProcessSelector).process.stepOne
  const userImportApiEnabled = useUserImportApiEnabled(stepOneData.companyId)
  const stepTwoData = useSelector(rootProcessSelector).process.stepTwo
  const stepThreeData = useSelector(stepThreeSelector)
  const stepFiveData = useSelector(rootProcessSelector).process.stepFive
  const test360Data = useSelector(selectTest360Data)
  const users360Data = useSelector(selectEvaluatedUsers)
  const evaluators360Data = useSelector(selectEvaluators)

  const [creditTestsAvailable, setCreditTestsAvailable] = useState<number | 'Ilimitado'>(0)
  const [credit360Available, setCredit360Available] = useState<number | 'Ilimitado'>(0)
  const [stateInventory, setStateInventory] = useState<boolean | null>(null)
  const [inventory, setInventory] = useState<SubscriptionByProcessData | null>(null)
  const multiplierCredits = stepThreeData.useBetesaTest && stepThreeData.useSkillsTest ? 2 : 1

  const { isUsersLoaded, addedUsers: usersDB, isProcessFinished } = useGetUsersByProcess(stepOneData)

  const typesOfTest = `${stepThreeData?.useBetesaTest ? (stepThreeData.useSkillsTest ? 'Betesa - ' : 'Betesa ') : ''} ${
    stepThreeData?.useSkillsTest ? 'Competencias' : ''
  }`

  const userListAdded = stepFiveData?.userListAdded || []

  const [loading, setLoading] = useState(false)
  const [pageUsers, setPageUsers] = useState(1)
  const [pageUsersAdded, setPageUsersAdded] = useState(1)
  const [pageUsers360, setPageUsers360] = useState(1)
  const [pageEvaluators, setPageEvaluators] = useState(1)
  const [searchOnEnter, setSearchOnEnter] = useState(false)
  const [name, setName] = useState('')
  const [identification, setIdentification] = useState('')
  const [email, setEmail] = useState('')
  const [requisitionCode, setRequisitionCode] = useState(stepOneData.requisitionCode || '')
  const [addedUsers, setAddedUsers] = useState<User[]>(userListAdded)
  const [addedEvaluators, setAddedEvaluators] = useState<EvaluatorProps[]>([])
  const [addedUsers360, setAddedUsers360] = useState<User[]>([])

  const refreshAddedUserStatuses = async (): Promise<void> => {
    if (!stepOneData.processId) return
    try {
      const response = await getUsersByProcess(stepOneData.processId, {
        limit: 1000000,
        viewUsersWithoutTests: true,
        retrieveAllUsers: true,
      })
      if (response.status !== 'OK') return
      const statusesByDocument = new Map<string, User['test_statuses']>(
        response.data.map((user) => [user.document, user.test_statuses])
      )
      setAddedUsers((currentUsers) => currentUsers.map((user) => ({
        ...user,
        test_statuses: statusesByDocument.get(user.document) || user.test_statuses,
      })))
    } catch (error) {
      console.error('No se pudo actualizar el estado de las pruebas', error)
    }
  }

  const [openDisclaimerModal, setOpenDisclaimerModal] = useState(stepFiveData?.acceptedTerms || false)
  const [openUploadModal, setOpenUploadModal] = useState(false)
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set())
  const [uploadedbyFile, setUploadedbyFile] = useState(false)
  const [newUserIdCreated, setNewUserIdCreated] = useState<number | null>(newUserId)
  const [openFinishModal, setOpenFinishModal] = useState(false)
  const [allowIntegration, setAllowIntegration] = useState(false)
  const [loadingUserId, setLoadingUserId] = useState<string | null>(null)
  const [addUserProgress, setAddUserProgress] = useState<string>('Asignando pruebas al usuario...')
  const addingUserInFlight = useRef(false)
  const [loadingCredits, setLoadingCredits] = useState(false)
  const [isAddingAnyUser, setIsAddingAnyUser] = useState(false)
  const [isDeletingUser, setIsDeletingUser] = useState(false)
  const [deletingUserId, setDeletingUserId] = useState<string | null>(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [user360ToDelete, setUser360ToDelete] = useState<string | null>(null)
  const [isFinishedProcess, setIsFinishedProcess] = useState(false)

  const users360TableRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (location.state) {
      setIsFinishedProcess(location.state.isSendedProcess || false)
    }
  }, [location])

  useEffect(() => {
    if (users360Data?.length) {
      setAddedUsers360(users360Data)
    }
    if (evaluators360Data?.length) {
      setAddedEvaluators(evaluators360Data)
    }
  }, [evaluators360Data, users360Data])

  useEffect(() => {
    setInventory(null)
  }, [stepOneData.processId])

  const updateInventory = useCallback((current: SubscriptionByProcessData) => {
    setInventory(current)
    setStateInventory(current.state)
    if (Number(stepOneData.inventoryTypeId) !== current.subscription_company_id) {
      dispatch(setStepOne({
        ...stepOneData,
        inventoryTypeId: current.subscription_company_id,
        inventoryUniqName: current.subscriptionName,
        inventoryType: current.subscriptionId,
      }))
    }
  }, [dispatch, stepOneData])

  // Función para obtener créditos del backend para Betesa y Skills
  const refreshCredits = useCallback(async () => {
    if (!stepOneData.processId) return

    let retryCount = 0
    const maxRetries = 3
    const retryDelay = 1000 // 1 segundo entre reintentos

    const fetchCredits = async (): Promise<boolean> => {
      try {
        const response = await getSubscriptionByProcess(stepOneData.processId)
        if (response.status === 'success') {
          const credits = response.data.creditsAvailable
          setCreditTestsAvailable(credits > 9999999 ? 'Ilimitado' : credits)
          updateInventory(response.data)
          return true
        } else {
          console.warn('Respuesta no exitosa al obtener créditos:', response.error)
          return false
        }
      } catch (error) {
        console.error('Error al obtener los créditos:', error)
        return false
      }
    }

    let success = await fetchCredits()

    while (!success && retryCount < maxRetries) {
      retryCount++
      await new Promise((resolve) => setTimeout(resolve, retryDelay))
      success = await fetchCredits()
    }

    if (!success) {
      getError('No se pudieron obtener los créditos disponibles después de varios intentos')
    }
  }, [stepOneData.processId, getError, updateInventory])

  // Función para obtener créditos iniciales del backend para Test 360
  const refresh360Credits = useCallback(async () => {
    if (!stepOneData.processId) return

    let retryCount = 0
    const maxRetries = 3
    const retryDelay = 1000

    const fetchCredits = async (): Promise<boolean> => {
      try {
        const response = await getSubscriptionByProcess(stepOneData.processId)
        if (response.status === 'success') {
          const credits = response.data.creditsAvailable
          const adjustedCredits: number | 'Ilimitado' = credits > 9999999 ? 'Ilimitado' : credits
          setCredit360Available(adjustedCredits)
          updateInventory(response.data)
          return true
        } else {
          console.warn('Respuesta no exitosa al obtener créditos Test 360:', response.error)
          return false
        }
      } catch (error) {
        console.error('Error al obtener los créditos Test 360:', error)
        return false
      }
    }

    let success = await fetchCredits()

    while (!success && retryCount < maxRetries) {
      retryCount++
      await new Promise((resolve) => setTimeout(resolve, retryDelay))
      success = await fetchCredits()
    }

    if (!success) {
      getError('No se pudieron obtener los créditos Test 360 disponibles después de varios intentos')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepOneData.processId, getError, isFinishedProcess, updateInventory])

  useEffect(() => {
    if (resultsFail.length > 0) {
      dispatch(setUserListFailed(resultsFail))
      dispatch(setLinkDownloadExcelUsersFailed(urlExcelUsersFailed))
    }
  }, [resultsFail, urlExcelUsersFailed, dispatch])

  const paginatedAddedUsers = useMemo(() => {
    if (addedUsers.length === 0) return []

    const uniqueUsers = _.uniqBy(addedUsers, 'document')
    const usersFormatted = uniqueUsers.map((user) => ({
      ...user,
      test_status: formatTestStatuses(
        user.test_statuses,
        [stepThreeData.useBetesaTest ? 1 : 0, stepThreeData.useSkillsTest ? 2 : 0].filter(Boolean),
        user.test_sent
      ),
      test_types:
        user.test_types && user.test_types.includes('Competencias')
          ? user.test_types.replace('Competencias', t('global.common.skillText'))
          : user.test_types,
    }))

    const sortedAddedUsers = [...usersFormatted].sort((a, b) => {
      if (a.test_sent === b.test_sent) return 0
      return a.test_sent ? 1 : -1
    })

    const firstIndex = (pageUsersAdded - 1) * DEFAULT_LIMIT
    const lastIndex = firstIndex + DEFAULT_LIMIT

    return sortedAddedUsers.slice(firstIndex, lastIndex)
  }, [addedUsers, pageUsersAdded, t, stepThreeData.useBetesaTest, stepThreeData.useSkillsTest])

  const uniqueEvaluators = useMemo(() => {
    return (
      addedEvaluators?.reduce((acc: EvaluatorProps[], current) => {
        const isDuplicate = acc.find((item) => item.email === current.email)
        if (!isDuplicate) {
          acc.push(current)
        }
        return acc
      }, []) || []
    )
  }, [addedEvaluators])

  const paginatedUsers360 = useMemo(() => {
    if (addedUsers360?.length === 0) return []

    const modifiedUsers =
      addedUsers360?.map((user) => {
        const assignedUser = usersDB.find((item) => item.email === user.email)
        const testStatuses = assignedUser?.test_statuses || user.test_statuses
        const testSent = assignedUser?.test_sent || user.test_sent
        return {
          ...user,
          test_statuses: testStatuses,
          test_sent: testSent,
          test_status: formatTestStatuses(testStatuses, [3], testSent),
          test_types: typesOfTest.length > 1 ? `${typesOfTest} - 360°` : '360°',
          evaluatorsCount: `${user?.evaluators?.length || 0} evaluadores`,
        }
      }) || []

    const sortedUsers = [...modifiedUsers].sort((a, b) => {
      if (a.test_sent === b.test_sent) return 0
      return a.test_sent ? 1 : -1
    })

    const firstIndex = (pageUsers360 - 1) * DEFAULT_LIMIT
    const lastIndex = firstIndex + DEFAULT_LIMIT

    return sortedUsers.slice(firstIndex, lastIndex)
  }, [addedUsers360, pageUsers360, typesOfTest, usersDB])

  const paginatedEvaluators360 = useMemo(() => {
    if (uniqueEvaluators.length === 0) return []

    const modifiedEvaluators = uniqueEvaluators.map((evaluator) => {
      const usersCount = addedUsers360?.reduce((count, user) => {
        const isEvaluatorForUser = user.evaluators?.some((userEvaluator) => userEvaluator.email === evaluator.email)

        return isEvaluatorForUser ? count + 1 : count
      }, 0)

      return {
        ...evaluator,
        evaluated: `${usersCount} evaluados`,
      }
    })

    const firstIndex = (pageEvaluators - 1) * DEFAULT_LIMIT
    const lastIndex = firstIndex + DEFAULT_LIMIT

    return modifiedEvaluators.slice(firstIndex, lastIndex)
  }, [uniqueEvaluators, addedUsers360, pageEvaluators])

  const handleAcceptDisclaimer = (isAcceptTerms: boolean) => {
    if (isAcceptTerms) {
      setOpenDisclaimerModal(isAcceptTerms)
      dispatch(setAcceptedTerms(isAcceptTerms))

      const dataToSaveProcess: any = {
        users: {
          process_id: stepOneData.processId,
          users_id: [],
        },
      }
      dispatch(setStepFiveTrigger.run(dataToSaveProcess))
    } else {
      getWarning('Debes aceptar los términos y condiciones para continuar')
    }
  }

  const handleAddUsersFromExcel = async (userList: User[]) => {
    setLoadingCredits(true)

    // Para Test 360, usar créditos específicos y lógica local
    const creditsToCheck = test360Data.length > 0 ? credit360Available : creditTestsAvailable
    const creditsNeeded = test360Data.length > 0 ? userList.length : userList.length * multiplierCredits

    if (creditsToCheck !== 'Ilimitado' && (creditsToCheck <= 0 || creditsNeeded > creditsToCheck)) {
      getWarning(
        `El numero de usuarios y pruebas que intentas cargar (${creditsNeeded}) supera el numero de pruebas disponibles (${creditsToCheck})`
      )
      setLoadingCredits(false)
      return
    } else {
      dispatch(setUserListFailed([]))
      dispatch(setLinkDownloadExcelUsersFailed(''))

      try {
        // Preparamos todos los usuarios sin filtrar para enviar al backend
        const usersToCreate = userList.map((user: any) => {
          return {
            document: user.document,
            documentType: user.document_type,
            email: user.email,
            firstName: user.first_name,
            lastName: user.last_name,
            test_types: typesOfTest,
            id: user.document,
            active: user.active,
          }
        })

        // Enviamos todos los usuarios al backend, que ahora se encarga de la validación
        // y capturamos la respuesta directamente
        const response = await createUsersBatch(usersToCreate as any, stepOneData.processId)

        // Usamos los datos de la respuesta directamente en lugar de los estados
        const {
          resultsSucess: newUsers,
          resultsFail: rejectedUsers,
        } = response

        // Preparar las personas incorporadas al proceso
        const newUsersCreatedPlaceholders = (newUsers || []).map((user: any) => {
          return {
            ...user,
            first_name: user.firstName,
            last_name: user.lastName,
            document: user.document,
            email: user.email,
            test_types: typesOfTest,
          }
        })

        const allAddedUsers = [...addedUsers, ...newUsersCreatedPlaceholders]

        const uniqueUsers = _.uniqBy(allAddedUsers, 'document')

        setAddedUsers(uniqueUsers as any)
        dispatch(setUserListAdded([...uniqueUsers]))

        await new Promise((resolve) => setTimeout(resolve, 1000))

        await refreshAddedUserStatuses()

        // Actualizar créditos según el tipo de test
        if (test360Data.length > 0) {
          await refresh360Credits()
        } else {
          // Para otros tests, usar la lógica original
          await refreshCredits()
        }

        setOpenUploadModal(false)
        setUploadedbyFile(true)

        getSuccess(t('global.notifications.addedMoreUsersSuccess'))
        if (rejectedUsers.length > 0) {
          getWarning(`${rejectedUsers.length} usuarios no se agregaron. Revisa los motivos en la lista de rechazados.`)
        }

        // Mantener el estado de carga un poco más para dar feedback visual
        setTimeout(() => {
          setLoadingCredits(false)
        }, 500)
      } catch (error) {
        getError(error instanceof Error ? error.message : 'Ocurrió un error al procesar el archivo Excel')
        setLoadingCredits(false)
      }
    }
  }

  const handleRemoveUser = (userDocument: string) => {
    if (isDeletingUser || isAddingAnyUser) return

    setIsDeletingUser(true)
    setDeletingUserId(userDocument)
    setLoadingCredits(true)

    let warningMessage = ''

    try {
      if (selectedItems.size > 0) {
        const updatedUsers = addedUsers.filter((user: any) => !selectedItems.has(user.userDocument))

        const idUsersToDelete = addedUsers
          .filter((user: any) => selectedItems.has(user.userDocument))
          .map((user: any) => user.id)

        if (idUsersToDelete.length > 0) {
          deleteUsersInProcess(stepOneData.processId, idUsersToDelete)
            .then(async (deleted: boolean) => {
              if (!deleted) {
                setIsDeletingUser(false)
                setDeletingUserId(null)
                setLoadingCredits(false)
                return
              }
              setAddedUsers(updatedUsers)
              setSelectedItems(new Set())
              dispatch(setUserListAdded([...updatedUsers]))
              warningMessage = 'Se eliminaron los usuarios seleccionados'
              getWarning(warningMessage)

              await new Promise((resolve) => setTimeout(resolve, 500))

              // Actualizar créditos según el tipo de test
              if (test360Data.length > 0) {
                await refresh360Credits()
              } else {
                // Para otros tests, usar la lógica original
                await refreshCredits()
              }

              setTimeout(() => {
                setIsDeletingUser(false)
                setDeletingUserId(null)
                setLoadingCredits(false)
              }, 500)
            })
            .catch((error) => {
              console.error('Error al eliminar usuarios:', error)
              getError('Error al eliminar los usuarios seleccionados')
              setIsDeletingUser(false)
              setDeletingUserId(null)
              setLoadingCredits(false)
            })
        } else {
          setAddedUsers(updatedUsers)
          setSelectedItems(new Set())
          dispatch(setUserListAdded([...updatedUsers]))
          warningMessage = 'Se eliminaron los usuarios seleccionados'
          getWarning(warningMessage)

          setTimeout(async () => {
            await new Promise((resolve) => setTimeout(resolve, 500))

            // Actualizar créditos según el tipo de test
            if (test360Data.length > 0) {
              await refresh360Credits()
            } else {
              // Para otros tests, usar la lógica original
              await refreshCredits()
            }

            setIsDeletingUser(false)
            setDeletingUserId(null)
            setLoadingCredits(false)
          }, 0)
        }
      } else {
        const updatedUsers = addedUsers.filter((user) => user.document !== userDocument)
        const idUserToDelete = addedUsers.find((user) => user.document === userDocument)?.id

        if (typeof idUserToDelete === 'number') {
          deleteUsersInProcess(stepOneData.processId, [idUserToDelete])
            .then(async (deleted: boolean) => {
              if (!deleted) {
                setIsDeletingUser(false)
                setDeletingUserId(null)
                setLoadingCredits(false)
                return
              }
              setAddedUsers(updatedUsers)
              dispatch(setUserListAdded([...updatedUsers]))
              warningMessage = t('global.notifications.userDeletedSuccess')
              getWarning(warningMessage)

              await new Promise((resolve) => setTimeout(resolve, 500))

              // Actualizar créditos según el tipo de test
              if (test360Data.length > 0) {
                await refresh360Credits()
              } else {
                // Para otros tests, usar la lógica original
                await refreshCredits()
              }

              setTimeout(() => {
                setIsDeletingUser(false)
                setDeletingUserId(null)
                setLoadingCredits(false)
              }, 500)
            })
            .catch((error) => {
              console.error('Error al eliminar usuario:', error)
              getError('Error al eliminar el usuario')
              setIsDeletingUser(false)
              setDeletingUserId(null)
              setLoadingCredits(false)
            })
        } else {
          setAddedUsers(updatedUsers)
          dispatch(setUserListAdded([...updatedUsers]))
          warningMessage = t('global.notifications.userDeletedSuccess')
          getWarning(warningMessage)

          setTimeout(async () => {
            await new Promise((resolve) => setTimeout(resolve, 500))

            // Actualizar créditos según el tipo de test
            if (test360Data.length > 0) {
              await refresh360Credits()
            } else {
              // Para otros tests, usar la lógica original
              await refreshCredits()
            }

            setIsDeletingUser(false)
            setDeletingUserId(null)
            setLoadingCredits(false)
          }, 0)
        }
      }
    } catch (error) {
      console.error('Error al ejecutar la eliminación:', error)
      getError('Ocurrió un error inesperado al eliminar')
      setIsDeletingUser(false)
      setDeletingUserId(null)
      setLoadingCredits(false)
    }
  }

  const handleAddUser = async (userToAdd: UserAdded) => {
    // Para Test 360, usar créditos específicos
    const creditsToCheck = test360Data.length > 0 ? credit360Available : creditTestsAvailable

    if (test360Data.length > 0 && creditsToCheck !== 'Ilimitado' && creditsToCheck <= 0) {
      getWarning(t('global.notifications.buyMoreCredits'))
      return
    }

    if (stateInventory === false) {
      getWarning(t('global.notifications.inventoryInactive'))
      return
    }

    if (!addedUsers.find((user) => user.document === userToAdd.document) && !isAddingAnyUser && !addingUserInFlight.current) {
      addingUserInFlight.current = true
      setAddUserProgress('Asignando pruebas al usuario...')
      setLoadingUserId(userToAdd.document)
      setLoadingCredits(true)
      setIsAddingAnyUser(true)
      try {
        const userToAddData: User = {
          ...userToAdd,
          test_types: typesOfTest,
        }

        const updatedUsers = mergeUsers(addedUsers, [userToAddData])

        const dataToSaveProcess: any = {
          users: {
            subscription_company_id: stepOneData.inventoryTypeId,
            users_id: [userToAddData.id],
          },
        }

        const response = await updateProcess(stepOneData.processId, dataToSaveProcess)

        if (response.status !== 'OK') {
          getWarning(response.error || 'No se pudo agregar el usuario')
          return
        }

        setAddedUsers(updatedUsers)
        dispatch(setUserListAdded([...updatedUsers]))

        await refreshAddedUserStatuses()

        setAddUserProgress('Actualizando el inventario...')
        if (test360Data.length > 0) {
          await refresh360Credits()
        } else {
          await refreshCredits()
        }
        getSuccess(t('global.notifications.addUserSuccess'))
      } catch (error) {
        console.error('Error al agregar usuario:', error)
        getError(getAddUserErrorMessage(error))
      } finally {
        addingUserInFlight.current = false
        setLoadingUserId(null)
        setLoadingCredits(false)
        setIsAddingAnyUser(false)
      }
    }
  }

  const handleNext = async () => {
    if (addedUsers360?.length > 0) {
      setLoading(true)
      try {
        // Primero obtener el draft actual para preservar su estructura
        const currentDraft = await test360GetDraft(stepOneData.processId)

        if (currentDraft && currentDraft.data && currentDraft.data.test360) {
          // Actualizar el draft preservando toda la estructura existente, solo cambiando el step
          const updateResponse = await test360UpdateDraft(stepOneData.processId, {
            test360: {
              ...currentDraft.data.test360,
              step: 3,
            },
          })

          // Manejar error 402 de créditos insuficientes
          if (updateResponse && updateResponse.success === false && updateResponse.message) {
            setLoading(false)
            getError(updateResponse.message)
            return
          }
        } else {
          // Si no hay draft previo, crear uno básico con step 3
          const updateResponse = await test360UpdateDraft(stepOneData.processId, {
            test360: {
              step: 3,
              users: addedUsers360?.map((user: any) => {
                const { id, user_id, user_test_id, test_types, document, ...userRest } = user
                return userRest
              }),
              evaluators: evaluators360Data.map((evaluator: any) => {
                const { id, user_id, user_test_id, document, ...evaluatorRest } = evaluator
                return evaluatorRest
              }),
            },
          })

          // Manejar error 402 de créditos insuficientes
          if (updateResponse && updateResponse.success === false && updateResponse.message) {
            setLoading(false)
            getError(updateResponse.message)
            return
          }
        }

        // Luego llamar al endpoint para crear el proceso Test 360
        const response = await test360CreateProcess(stepOneData.processId)

        if (response.message === 'Test 360 created successfully') {
          // Crear un mapa para preservar evaluated_role de los usuarios actuales en Redux
          const currentUsersMap = new Map(addedUsers360.map((user) => [user.email, user.evaluated_role]))

          // Restaurar evaluated_role en los usuarios de la respuesta
          const usersWithEvaluatedRole = response.data.users.map((user: any) => ({
            ...user,
            evaluated_role: currentUsersMap.get(user.email) || user.evaluated_role,
          }))

          dispatch(setEvaluatedUsers(usersWithEvaluatedRole))

          const evaluatorsMap = new Map()

          response.data.users.forEach((user: any) => {
            if (user.evaluators && Array.isArray(user.evaluators)) {
              user.evaluators.forEach((evaluator: any) => {
                if (evaluator.email) {
                  evaluatorsMap.set(evaluator.email, {
                    user_id: evaluator.user_id,
                    user_test_id: evaluator.user_test_id,
                  })
                }
              })
            }
          })

          const updatedEvaluators = evaluators360Data.map((evaluator: any) => {
            const matchingData = evaluatorsMap.get(evaluator.email)

            if (matchingData) {
              return {
                ...evaluator,
                document: evaluator.document,
                id: matchingData.user_id,
                user_id: matchingData.user_id,
                user_test_id: matchingData.user_test_id,
              }
            }
            return evaluator
          })

          dispatch(setEvaluators(updatedEvaluators))
          setLoading(false)
          navigate(platformAdminRoutes.Resume, { state: { uploadedbyFile } })
        } else {
          setLoading(false)
          console.error('Error al crear el proceso de Test 360:', response)
          getError('Ha ocurrido un error al crear el proceso de Test 360°')
        }
      } catch (error) {
        setLoading(false)
        console.error('Error al crear el proceso de Test 360:', error)
        getError('Ha ocurrido un error al crear el proceso de Test 360°')
      }
    } else if (addedUsers.length > 0) {
      navigate(platformAdminRoutes.Resume, { state: { data: addedUsers, uploadedbyFile } })
    } else {
      getWarning(t('global.notifications.addUsersBeforeContinue'))
    }
  }

  useEffect(() => {
    const refresh = async () => {
      setLoadingCredits(true)
      try {
        getOneCompany(stepOneData.companyId)
        if (test360Data.length > 0) {
          await refresh360Credits()
        } else {
          await refreshCredits()
        }
      } finally {
        setTimeout(() => {
          setLoadingCredits(false)
        }, 500)
      }
    }
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepOneData.companyId, test360Data.length])

  useEffect(() => {
    if (stepOneData.processId) {
      if (isUsersLoaded) {
        const users = usersDB.map((user: any) => {
          return {
            id: user.userId ?? user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            company_name: user.company_name,
            document: user.document,
            email: user.email,
            test_types: typesOfTest,
            test_sent: user.test_sent,
            test_statuses: user.test_statuses,
            active: user.active,
            language: user.language,
          }
        })

        if (newUserIdCreated) {
          const allAddedUsers = mergeUsers(addedUsers, users, newUserId)
          const uniqAddedUsers = _.uniqBy(allAddedUsers, 'document')

          setAddedUsers(uniqAddedUsers)
          setNewUserIdCreated(null)
        } else {
          const allAddedUsers = mergeUsers(addedUsers, users)
          const uniqAddedUsers = _.uniqBy(allAddedUsers, 'document')
          setAddedUsers(uniqAddedUsers)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepOneData.processId, isUsersLoaded, typesOfTest])

  useEffect(() => {
    getCompanyInfo(stepOneData.companyId)
      .then((response) => {
        if (response.status === 'OK') {
          setAllowIntegration(response.data[0].allow_integration)
        }
      })
      .catch(() => {
        getError('Ha ocurrido un error al intentar obtener la información de la compañía')
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepOneData.companyId])

  useEffect(() => {
    if (searchOnEnter) {
      search({ documentFilter: identification, nameFilter: name, emailFilter: email, requisitionCode: userImportApiEnabled ? requisitionCode : undefined, companyId: stepOneData.companyId, role: [USER_ROLE_ID.user] })
      setSearchOnEnter(false)
    }
  }, [search, searchOnEnter, identification, name, email, requisitionCode, stepOneData.companyId, userImportApiEnabled])

  useEffect(() => {
    if (listUsersByProcess.length > 0) {
      const users = listUsersByProcess.map((user: any) => {
        return {
          id: user.userId ?? user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          document: user.document,
          email: user.email,
          test_types: typesOfTest,
          test_sent: user.test_sent,
          test_statuses: user.test_statuses,
        }
      })

      const uniqueUsers = _.uniqBy(users, 'document')

      setAddedUsers(uniqueUsers || [])
    }
  }, [listUsersByProcess, typesOfTest])

  // Resetear página de usuarios agregados si la página actual ya no es válida
  useEffect(() => {
    const uniqueUsers = _.uniqBy(addedUsers, 'document')
    const totalPages = Math.ceil(uniqueUsers.length / DEFAULT_LIMIT)

    if (pageUsersAdded > totalPages && totalPages > 0) {
      setPageUsersAdded(totalPages)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedUsers.length, pageUsersAdded])

  // Resetear página de usuarios 360 si la página actual ya no es válida
  useEffect(() => {
    const totalPages = Math.ceil(addedUsers360?.length / DEFAULT_LIMIT)

    if (pageUsers360 > totalPages && totalPages > 0) {
      setPageUsers360(totalPages)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedUsers360?.length, pageUsers360])

  // Resetear página de evaluadores 360 si la página actual ya no es válida
  useEffect(() => {
    const totalPages = Math.ceil(uniqueEvaluators.length / DEFAULT_LIMIT)

    if (pageEvaluators > totalPages && totalPages > 0) {
      setPageEvaluators(totalPages)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueEvaluators.length, pageEvaluators])

  const handlePagination = useCallback(
    (page: number) => {
      setPageUsers(page)
      search({
        documentFilter: identification,
        nameFilter: name,
        emailFilter: email,
        requisitionCode: userImportApiEnabled ? requisitionCode : undefined,
        companyId: stepOneData.companyId,
        page: page.toString(),
        role: [USER_ROLE_ID.user],
        processFinished: false,
      })
    },
    [email, identification, name, requisitionCode, search, stepOneData.companyId, userImportApiEnabled]
  )

  const handleUsers360Pagination = useCallback((page: number) => {
    setPageUsers360(page)

    setTimeout(() => {
      if (users360TableRef.current) {
        users360TableRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }, 100)
  }, [])

  const handleMultipleDeleteUsersAdded = () => {
    const newAddedUsers = addedUsers.filter((user: any) => !selectedItems.has(user.id))
    setAddedUsers(newAddedUsers)
    setSelectedItems(new Set())
    dispatch(setUserListAdded([...newAddedUsers]))
    getSuccess('Se eliminaron los usuarios seleccionados')
  }

  const resultsWithCompanyName = useMemo(() => {
    return results.map((user: any) => {
      return {
        ...user,
        company_name: companyInfo?.data?.name || '',
      }
    })
  }, [results, companyInfo])

  const handleResetSearch = () => {
    setName('')
    setIdentification('')
    setEmail('')
    setRequisitionCode('')
    setSearchOnEnter(false)
    setPageUsers(1)
    clearSearch()
  }

  const handleOmitStep = async () => {
    try {
      const finishProcess = await updateProcess(stepOneData?.processId, { finishProcess: true })
      const userId = stepOneData?.userId
      const admins = stepOneData?.admins.length > 0 ? stepOneData.admins : []
      const adminIdsToSave = userId !== undefined ? [userId, ...admins] : [...admins]
      const saveAdmins = await updateAdmins(stepOneData?.processId, adminIdsToSave)
      if (finishProcess.status === 'OK' && saveAdmins.status === 'OK') {
        getSuccess('Se ha guardado el proceso correctamente')
        navigate(platformAdminRoutes.ProcessesCreated)
      }
    } catch (error) {
      console.error('error on omit step', error)
      getError('Ha ocurrido un error al guardar el proceso')
    }
  }

  const handleClickAddUsersFromExcelButton = () => {
    if (stateInventory === false) {
      getWarning(t('global.notifications.inventoryInactive'))
      return
    }

    setOpenUploadModal(true)
    setTimeout(() => {
      console.log('Estado de openUploadModal después del timeout:', openUploadModal)
    }, 500)
  }

  const handleCreateNewUserButton = () => {
    // Para Test 360, usar créditos específicos
    const creditsToCheck = test360Data.length > 0 ? credit360Available : creditTestsAvailable

    if (creditsToCheck !== 'Ilimitado' && creditsToCheck <= 0) {
      getWarning(t('global.notifications.buyMoreCredits'))
      return
    }

    if (stateInventory === false) {
      getWarning(t('global.notifications.inventoryInactive'))
      return
    }

    navigate(platformAdminRoutes.NewUser)
  }

  // Mantenemos las versiones originales para compatibilidad con otras partes del código
  const modifiedUsers360 = addedUsers360?.map((user) => {
    return {
      ...user,
      test_types: typesOfTest.length > 1 ? `${typesOfTest} - 360°` : '360°',
      evaluatorsCount: `${user?.evaluators?.length || 0} evaluadores`,
    }
  })

  const modifiedEvaluators360 = uniqueEvaluators.map((evaluator) => {
    const usersCount = addedUsers360?.reduce((count, user) => {
      const isEvaluatorForUser = user.evaluators?.some((userEvaluator) => userEvaluator.email === evaluator.email)

      return isEvaluatorForUser ? count + 1 : count
    }, 0)

    return {
      ...evaluator,
      evaluated: `${usersCount} evaluados`,
    }
  })

  const DeleteUser360Component = (item: User) => {
    const emailId = item.email
    const hasAnswers = hasAnsweredTest(item.test_statuses, item.test_sent)
    const isDeleting = deletingUserId === emailId
    const isDisabled = isDeletingUser || isAddingAnyUser
    const actionLabel = isDeleting ? 'Eliminando...' : 'Eliminar'

    if (selectedItems.size > 0 || hasAnswers) return <ContainerActions />

    return (
      <ContainerActions title={actionLabel}>
        <DeleteActionButton
          type="button"
          disabled={isDisabled}
          aria-label={actionLabel}
          onClickCapture={(event) => {
            event.preventDefault()
            event.stopPropagation()
            setUser360ToDelete(emailId)
            setShowDeleteModal(true)
          }}
          style={{
            cursor: isDisabled ? 'default' : 'pointer',
            opacity: isDisabled && !isDeleting ? 0.6 : 1,
          }}
        >
          {isDeleting ? <CircularProgress size={18} color="error" /> : <DeleteOutlineIcon fontSize="small" />}
        </DeleteActionButton>
      </ContainerActions>
    )
  }

  const handleRemoveUser360 = async () => {
    if (isDeletingUser) return

    setIsDeletingUser(true)
    setDeletingUserId(user360ToDelete)
    setLoadingCredits(true)

    try {
      setShowDeleteModal(false)

      const userToDelete = addedUsers360.find((user) => user.email === user360ToDelete)

      if (!userToDelete) {
        getWarning('No se encontró el usuario seleccionado')
        return
      }

      // Call the new service to delete the user
      if (!user360ToDelete) {
        getWarning('No se encontró el usuario seleccionado')
        return
      }

      const deleteResponse = await test360DeleteUsers(stepOneData.processId, [user360ToDelete])

      // Handle error response
      if (!deleteResponse.success) {
        getError(deleteResponse.message || 'Ha ocurrido un error al intentar eliminar el usuario')
        return
      }

      // Update local state after successful deletion
      const evaluatorsToKeep = new Set<string>()

      const updatedUsers360 = addedUsers360.filter((user) => {
        if (user.email !== user360ToDelete && user.evaluators) {
          user.evaluators.forEach((evaluator) => {
            evaluatorsToKeep.add(evaluator.email)
          })
          return true
        }
        return false
      })

      const updatedEvaluators = addedEvaluators.filter((evaluator) => evaluatorsToKeep.has(evaluator.email))

      const removedEvaluatorsCount = addedEvaluators.length - updatedEvaluators.length

      setAddedUsers360(updatedUsers360)
      setAddedEvaluators(updatedEvaluators)
      dispatch(setEvaluatedUsers(updatedUsers360))
      dispatch(setEvaluators(updatedEvaluators))

      if (removedEvaluatorsCount > 0) {
        getSuccess(
          `Usuario eliminado correctamente de la base de datos. También se eliminaron ${removedEvaluatorsCount} evaluadores que solo estaban relacionados con este usuario.`
        )
      } else {
        getSuccess(
          'Usuario eliminado correctamente de la base de datos. No se eliminaron evaluadores ya que todos están relacionados con otros usuarios.'
        )
      }
    } catch (error) {
      console.error('Error al eliminar usuario 360:', error)
      getError('Ha ocurrido un error al intentar eliminar el usuario')
    } finally {
      setUser360ToDelete(null)
      setDeletingUserId(null)
      setIsDeletingUser(false)
      await refresh360Credits()
      setLoadingCredits(false)
    }
  }

  const handleCloseDelete360Modal = () => {
    setShowDeleteModal(false)
    setDeletingUserId(null)
    setIsDeletingUser(false)
  }

  // MARK: TEST 360 EXCEL

  const handleExcelForTest360 = async ({ users, evaluators }: { users: User[]; evaluators: EvaluatorProps[] }) => {
    setLoading(true)

    // Calcular usuarios realmente nuevos para validación de créditos
    let newUsersToAdd = users.length

    if (isFinishedProcess) {
      // Si el proceso está terminado, calcular solo los usuarios verdaderamente nuevos
      const existingUserEmails = new Set(addedUsers360?.map((user) => user.email))
      newUsersToAdd = users.filter((user) => !existingUserEmails.has(user.email)).length
    }

    // Validar créditos disponibles antes de procesar
    if (credit360Available !== 'Ilimitado' && newUsersToAdd > credit360Available) {
      setLoading(false)
      getWarning(
        `El número de usuarios evaluados nuevos que intentas cargar (${newUsersToAdd}) supera el número de créditos disponibles (${credit360Available}). Por favor, reduce la cantidad de usuarios evaluados en el archivo Excel.`
      )
      return
    }

    try {
      const modifiedUsers = users.map((user) => {
        return {
          ...user,
          language: 'es',
        }
      })

      // Crear un mapa para preservar evaluated_role de los usuarios originales
      const evaluatedRoleMap = new Map(modifiedUsers.map((user) => [user.email, user.evaluated_role]))

      const body = {
        test360: {
          users: modifiedUsers,
          evaluators,
          step: 2,
        },
      }
      const draftResponse = await test360UpdateDraft(stepThreeData.processId, body)

      // Manejar respuesta del endpoint
      if (!draftResponse.success) {
        setLoading(false)
        getError(draftResponse.message)
        return
      }

      if (draftResponse.data && draftResponse.data.adminsRemoved) {
        getWarning('El archivo Excel contenía Administradores que fueron eliminados')
      }

      const previousUsersCount = addedUsers360?.length
      const newUsersCount = draftResponse.data?.test360?.users?.length || 0
      const usersAdded = newUsersCount - previousUsersCount

      if (draftResponse.data && draftResponse.data.test360) {
        // Restaurar evaluated_role desde el mapa ya que el backend no lo devuelve
        const usersWithEvaluatedRole = draftResponse.data.test360.users.map((user: any) => ({
          ...user,
          evaluated_role: evaluatedRoleMap.get(user.email) || user.evaluated_role,
        }))

        setAddedUsers360(usersWithEvaluatedRole)
        setAddedEvaluators(draftResponse.data.test360.evaluators)
        dispatch(setEvaluatedUsers(usersWithEvaluatedRole))
        dispatch(setEvaluators(draftResponse.data.test360.evaluators))
      }

      // Para Test 360, actualizar créditos siempre que haya cambios en los usuarios
      // (tanto cuando se agregan como cuando se reducen usuarios)
      await refresh360Credits()

      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('Error al manejar el Excel para Test 360:', error)
      getError('Ocurrió un error al procesar el archivo Excel para Test 360°')
    }
  }

  // MARK: REDUX CLEANUP

  const handleCleanup = () => {
    // Reset Redux state
    dispatch(set360Data([]))
    dispatch(setReduxShowSummary(false))
    dispatch(setReduxShowIntro(true))
    dispatch(setEvaluatedUsers([]))
    dispatch(setEvaluators([]))
    dispatch(setHas360Test(false))
  }

  usePreventNavigation({
    shouldPrevent: false,
    onNavigationAttempt: handleCleanup,
  })

  // MARK: RENDER

  return (
    <MainLayout>
      <Container>
        <HeaderContainer>
          {test360Data.length ? (
            <TitleContainer>
              <TitleIcon src={threeSixtyIcon} alt="threeSixtyIcon" />
              <PageTitle margin="0px 0px 30px 0">Agregar usuarios</PageTitle>
            </TitleContainer>
          ) : (
            <PageTitle margin="0px 0px 30px 30px">Agregar usuarios</PageTitle>
          )}
          <Stepper activeStep={4} steps={test360Data.length ? STEPS_NEW_PROCESS_360 : STEPS_NEW_PROCESS} />
        </HeaderContainer>
        {test360Data.length ? (
          <P fontSize="18px" margin="0">
            Agrega los usuarios que participarán de este proceso. Descarga la plantilla de Excel, llena los datos de los
            participantes y sus respectivos evaluadores, y sube a la plataforma la plantilla llena.
          </P>
        ) : (
          <P margin="0">Selecciona cómo deseas agregar usuarios a este proyecto (crear nuevo, agregar existente)</P>
        )}
        <InventoryToolbar>
          <InventorySummary aria-live="polite">
            <div style={{ fontWeight: 600 }}>
              Inventario del proceso: {inventory?.subscriptionName || (loadingCredits ? 'Consultando...' : 'No disponible')}
            </div>
            {inventory && (
              <div style={{ marginTop: '6px' }}>
                Estado: {inventory.state ? 'Activo' : 'Inactivo'} · Utilizadas: {inventory.usedCredits} · Disponibles: {formatAvailableCredits(inventory.creditsAvailable)}
              </div>
            )}
            {!inventory && loadingCredits && <CircularProgress size={18} sx={{ marginTop: '6px' }} />}
            {inventory && !inventory.state && (
              <div style={{ color: '#a65e00', marginTop: '6px' }}>
                Este inventario está inactivo; no puedes agregar usuarios con él.
              </div>
            )}
            <div style={{ color: '#52687b', marginTop: '6px', fontSize: '13px' }}>
              {test360Data.length > 0
                ? 'El saldo se consulta después de agregar o quitar participantes; los cambios mostrados vienen del servidor.'
                : 'Las pruebas se descuentan al asignarlas a un usuario. Se pueden devolver hasta el envío de la prueba al usuario.'}
            </div>
          </InventorySummary>
          <InventoryButtons>
            {stepOneData?.profileId && allowIntegration && !test360Data.length && (
              <StrokedButton
                onClick={() => {
                  setOpenFinishModal(true)
                }}
                style={{ marginBottom: '0' }}
              >
                Saltar este paso
              </StrokedButton>
            )}
            <StrokedButton
              onClick={handleClickAddUsersFromExcelButton}
              style={{ marginBottom: '0', display: 'flex', alignItems: 'center' }}
            >
              <NoteAddOutlinedIcon style={{ marginRight: '7px' }} />
              Importar desde excel
            </StrokedButton>
            {!test360Data.length && (
              <ButtonCreateNewUser onClick={handleCreateNewUserButton}>
                <AddCircleOutlineIcon /> Crear nuevo usuario
              </ButtonCreateNewUser>
            )}
          </InventoryButtons>
        </InventoryToolbar>
        {resultsFail.length > 0 && (
          <StrokedButton onClick={() => navigate(platformAdminRoutes.NotUpload)}>
            Ver {resultsFail.length} usuarios no agregados
          </StrokedButton>
        )}
        {!test360Data.length && (
          <UsersTableCard>
            <UsersSearchHeading>
              <UsersTableTitle>Buscar usuarios existentes</UsersTableTitle>
              <UsersSearchControls>
                <div style={{ flex: '1 1 170px', minWidth: '150px' }}>
                  <Input
                    name="identification"
                    type="text"
                    label="Número de identificación"
                    value={identification}
                    style={{ width: '100%' }}
                    onChange={(e) => setIdentification(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') setSearchOnEnter(true)
                    }}
                  />
                </div>
                <div style={{ flex: '1 1 170px', minWidth: '150px' }}>
                  <Input
                    name="email"
                    type="text"
                    label="Correo electrónico"
                    value={email}
                    style={{ width: '100%' }}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') setSearchOnEnter(true)
                    }}
                  />
                </div>
                <div style={{ flex: '1 1 170px', minWidth: '150px' }}>
                  <Input
                    name="name"
                    type="text"
                    label="Nombre"
                    value={name}
                    style={{ width: '100%' }}
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') setSearchOnEnter(true)
                    }}
                  />
                </div>
                {userImportApiEnabled && (
                  <div style={{ flex: '1 1 170px', minWidth: '150px' }}>
                    <Input
                      name="requisitionCode"
                      type="text"
                      label="Código de requisición"
                      value={requisitionCode}
                      style={{ width: '100%' }}
                      onChange={(e) => setRequisitionCode(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') setSearchOnEnter(true)
                      }}
                    />
                  </div>
                )}
                <ResetButton type="button" aria-label="Limpiar búsqueda" onClick={handleResetSearch}>
                  <HighlightOffIcon />
                </ResetButton>
                <SearchButton
                  type="button"
                  aria-label="Buscar usuarios"
                  onClick={() =>
                    search({
                      documentFilter: identification,
                      nameFilter: name,
                      emailFilter: email,
                      requisitionCode: userImportApiEnabled ? requisitionCode : undefined,
                      companyId: stepOneData.companyId,
                      role: [USER_ROLE_ID.user],
                    })
                  }
                >
                  <MagnifyingGlass src={IconMagnifying} alt="" />
                </SearchButton>
              </UsersSearchControls>
            </UsersSearchHeading>
            {resultsWithCompanyName.length > 0 && (
              <BluesiteTableComponent
                ActionComponent={AddUserAction}
                extraDataAction={{
                  addedUsers,
                  loadingUserId,
                  isAddingAnyUser,
                  onAddUser: handleAddUser,
                }}
                data={resultsWithCompanyName}
                headers={headers}
                searchBar={false}
                searchLabel=""
                handlePagination={handlePagination}
                totalPages={paginationUsers.total_pages}
                currentPage={pageUsers}
                tableStyle="process-users-search"
                minimumColumnWidth={150}
              />
            )}
          </UsersTableCard>
        )}
        {addedUsers.length && !addedUsers360?.length && !test360Data.length ? (
          <>
            <UsersTableCard>
              <UsersTableHeading>
                <UsersTableTitle>Usuarios agregados</UsersTableTitle>
                {selectedItems.size > 0 && (
                  <StrokedButton style={{ marginBottom: 0 }} onClick={handleMultipleDeleteUsersAdded}>
                    Eliminar seleccionados
                  </StrokedButton>
                )}
              </UsersTableHeading>
              <BluesiteTableComponent
                ActionComponent={DeleteUserAction}
                extraDataAction={{
                  selectedItems,
                  deletingUserId,
                  isDeletingUser,
                  isAddingAnyUser,
                  onRemoveUser: handleRemoveUser,
                }}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                checks={false}
                data={paginatedAddedUsers}
                headers={HEADERS_ADDED_USERS}
                searchBar={false}
                searchLabel=""
                currentPage={pageUsersAdded}
                totalPages={Math.ceil(addedUsers.length / DEFAULT_LIMIT)}
                handlePagination={setPageUsersAdded}
                showNumbers={true}
                tableStyle="process-users-added"
                minimumColumnWidth={150}
              />
            </UsersTableCard>
            <BottomButtonsContainer>
              <BackButton
                onClick={() => {
                  if (isProcessFinished) {
                    navigate(-2)
                  } else {
                    if (stepTwoData.isRoleFamilySelected) {
                      navigate(platformAdminRoutes.PreconfigProcess)
                    } else if (
                      stepTwoData?.configurationMode ===
                      'ai_ideal_profile'
                    ) {
                      navigate(platformAdminRoutes.IdealProfileGeneratorAi)
                    } else {
                      if (stepThreeData.useSkillsTest) {
                        navigate(platformAdminRoutes.ProcessSkills, { state: { back: true } })
                      } else if (!stepThreeData.useSkillsTest && stepThreeData.useBetesaTest) {
                        navigate(platformAdminRoutes.IdealProfileBetesa)
                      }
                    }
                  }
                }}
              />
              <Button
                onClick={handleNext}
                type="submit"
                disabled={isAddingAnyUser || isDeletingUser}
                style={{
                  opacity: isAddingAnyUser || isDeletingUser ? 0.7 : 1,
                  cursor: isAddingAnyUser || isDeletingUser ? 'not-allowed' : 'pointer',
                }}
              >
                {isAddingAnyUser || isDeletingUser ? 'Procesando...' : t('global.common.nextButtonText')}
              </Button>
            </BottomButtonsContainer>
          </>
        ) : addedUsers360?.length && addedEvaluators.length ? (
          <>
            <div ref={users360TableRef}>
              <UsersTableCard>
                <UsersTableHeading>
                  <UsersTableTitle>Usuarios agregados</UsersTableTitle>
                </UsersTableHeading>
                <BluesiteTableComponent
                  ActionComponent={DeleteUser360Component}
                  checks={false}
                  data={paginatedUsers360}
                  headers={HEADERS_ADDED_USERS_TEST_360}
                  searchBar={false}
                  searchLabel=""
                  currentPage={pageUsers360}
                  totalPages={Math.ceil(addedUsers360?.length / DEFAULT_LIMIT)}
                  handlePagination={handleUsers360Pagination}
                  showNumbers={true}
                  tableStyle="process-users-360"
                  minimumColumnWidth={150}
                />
              </UsersTableCard>
            </div>
            <Row justifyContent="flex-start" alignItems="center" gap="20px">
              <Test360Icon src={threeSixtyIcon} />
              <h5 style={{ margin: 5 }}>Lista de evaluadores 360°</h5>
            </Row>
            <BluesiteTableComponent
              checks={false}
              data={paginatedEvaluators360}
              headers={HEADERS_ADDED_EVALUATORS_TEST_360}
              searchBar={false}
              searchLabel=""
              currentPage={pageEvaluators}
              totalPages={Math.ceil(uniqueEvaluators.length / DEFAULT_LIMIT)}
              handlePagination={setPageEvaluators}
              showNumbers={true}
            />
            <BottomButtonsContainer>
              <BackButton
                onClick={() => {
                  if (isProcessFinished) {
                    navigate(-2)
                  } else {
                    navigate(platformAdminRoutes.Process360)
                  }
                }}
              />
              <Button
                onClick={handleNext}
                type="submit"
                disabled={isAddingAnyUser || isDeletingUser}
                style={{
                  opacity: isAddingAnyUser || isDeletingUser ? 0.7 : 1,
                  cursor: isAddingAnyUser || isDeletingUser ? 'not-allowed' : 'pointer',
                }}
              >
                {isAddingAnyUser || isDeletingUser ? 'Procesando...' : t('global.common.nextButtonText')}
              </Button>
            </BottomButtonsContainer>
          </>
        ) : (
          <BackButton
            style={{ marginTop: '100px' }}
            onClick={() => {
              if (isProcessFinished) {
                navigate(-2)
              } else {
                if (stepTwoData.isRoleFamilySelected) {
                  navigate(platformAdminRoutes.PreconfigProcess, { state: { goBack: true } })
                } else if (
                  stepTwoData?.configurationMode === 'ai_ideal_profile'
                ) {
                  navigate(platformAdminRoutes.IdealProfileGeneratorAi)
                } else {
                  if (stepThreeData.use360Test) {
                    navigate(platformAdminRoutes.Process360, { state: { back: true } })
                  } else if (stepThreeData.useSkillsTest) {
                    navigate(platformAdminRoutes.ProcessSkills, { state: { back: true } })
                  } else if (!stepThreeData.useSkillsTest && stepThreeData.useBetesaTest) {
                    navigate(platformAdminRoutes.IdealProfileBetesa)
                  }
                }
              }
            }}
          />
        )}
      </Container>
      <ModalLoader isLoading={loading} text={test360Data ? 'Estamos creando los usuarios, aguarda un instante' : ''} />
      <AddUserProgressDialog isOpen={isAddingAnyUser} progress={addUserProgress} />
      <DisclaimerModal
        accepTerms={openDisclaimerModal}
        setAccepTerms={(e) => {
          handleAcceptDisclaimer(e)
        }}
      />
      <UploadModal
        openModal={openUploadModal}
        setOpenModal={setOpenUploadModal}
        setAddedUsers={handleAddUsersFromExcel}
        setUploadedbyFile={setUploadedbyFile}
        setAddTest360FromExcel={handleExcelForTest360}
        canAddUsers={isFinishedProcess}
        addedEvaluators={addedEvaluators}
        addedUsers360={addedUsers360}
      />
      <FinishProcessModal
        showConfirmModal={openFinishModal}
        setShowConfirmModal={setOpenFinishModal}
        onConfirm={handleOmitStep}
      />
      <DeleteModal
        showModal={showDeleteModal}
        handleClose={handleCloseDelete360Modal}
        handleRemoveUser={handleRemoveUser360}
      />
    </MainLayout>
  )
}

export default CreateUsers
